// implements the MessageProvider typescript interface from '@atlassian/connect-module-core'
// the messages module is deprecated but it maps well enough to flags to just do that
class MessageProvider {
	constructor({ showFlag, hideFlag }) {
		this.showFlag = showFlag;
		this.hideFlag = hideFlag;
		this.messageIDs = {};
	}
	_createMessageType = (type) => (title, description, options) => {
		const { id } = this.showFlag({
			type,
			title,
			description,
			actions: [],
			close: options.fadeout ? 'auto' : 'manual',
			onClose: () => {
				const flag = this.messageIDs[options.id];
				if (typeof flag.onClose === 'function') {
					flag.onClose();
				}
				delete this.messageIDs[options.id];
			},
		});
		this.messageIDs[options.id] = { id };
	};
	// ADG3 only supports success, error, warning, and info,
	// the others can safely map to info
	error = this._createMessageType('error');
	generic = this._createMessageType('info');
	hint = this._createMessageType('info');
	info = this._createMessageType('info');
	success = this._createMessageType('success');
	warning = this._createMessageType('warning');
	clear = (id) => {
		const flag = this.messageIDs[id];
		if (flag) {
			this.hideFlag(flag.id);
			delete this.messageIDs[id];
		}
	};
	onClose = (id, callback) => {
		const flag = this.messageIDs[id];
		if (flag) {
			flag.onClose = callback;
		}
	};
}

export { MessageProvider };
